import myAjax from '../../global/libs/myAjax.js';
import $ from 'jquery';
import CONFIG from '../../global/libs/CONFIG.js';
import queryString from 'query-string';

let USER_INFO = {};

class Session {
  constructor() {
    this.sessionId = window.sessionStorage.getItem('X-SessionID');
  }
  get id() {
    return this.sessionId;
  }
  set id(sid) {
    this.sessionId = sid;
    window.sessionStorage.setItem('X-SessionID', sid);
  }
}

let SESSION = new Session();

function setUserInfoFromQuery(query) {
  let uid_query = queryString.parse(query).uid;
  if (uid_query) {
    USER_INFO['authorized'] = false;
    USER_INFO['uid'] = uid_query;
  }
}

function authenticate(callback) {
  let dfd = $.Deferred();

  myAjax('/is_ok/', null, 'GET', true, true)
    .done((data) => {
      USER_INFO['authorized'] = true;
      USER_INFO['uid'] = data.user_id;
      dfd.resolve();
    })
    .fail(() => {
      var browser = window.self;
      var url = CONFIG.BACKEND_SERVERURL + '/c/accounts/login/?f_opener=true';
      browser.open(url, '_blank', 'width=500,height=800');

      window.addEventListener('message', function (ev) {
        if (ev.data[0] === 'sessionId') {
          console.log(ev.data);
          SESSION.id = ev.data[1];
          myAjax('/is_ok/', null, 'GET', true, true)
            .done((data) => {
              USER_INFO['authorized'] = true;
              USER_INFO['uid'] = data.user_id;
              dfd.resolve();
            })
            .fail(() => {
              dfd.reject();
            });
        }
      });
    })
    .always(() => {
      callback();
    });

  return dfd.promise();
}

export {USER_INFO, authenticate, setUserInfoFromQuery, SESSION};
